/* eslint-disable parog-web/no-glint-expect-error-directive */
import AntecedentsFields from '../hemato-cancer/antecedents-fields';

<template>
  {{! @glint-expect-error }}
  <AntecedentsFields @form={{@form}} @patient={{@patient}} />
</template>
